import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { LoginPageComponent } from './auth/login-page/login-page.component';
import { AdminGuard } from './auth/guards/admin.guard';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { CodesComponent } from './codes/codes.component';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';

export const routes: Routes = [

    { 
        path: 'login', component: AuthLayoutComponent,
        children: [
            { path: 'callback', component: OktaCallbackComponent },
            { path: '', component: LoginPageComponent },
        ]
    },
    { 
        path: '', component: MainLayoutComponent, 
        children: [
            { path: 'codes', component: CodesComponent, 
                canActivate: [OktaAuthGuard], },
            {  path: '', redirectTo: '/codes', pathMatch: "full" },
        ]
    },
    {  path: '**', redirectTo: 'login', pathMatch: "full" },
];